var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #05a954;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,16c0,8.8-7.2,16-16,16C7.1,32,0,24.8,0,16,0,7.1,7.2,0,16,0c8.8,0,16,7.2,16,16ZM30.5,16c0-8-6.4-14.5-14.5-14.6C8.1,1.4,1.5,7.9,1.5,15.9c0,8,6.4,14.6,14.5,14.6,8,0,14.5-6.4,14.6-14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.4,22.4c0,.5-.2.9-.7,1-.9.3-1.7.6-2.7.6-1.9,0-2.8-1.2-2.4-3,.2-1.1.6-2.2.9-3.4.1-.6.3-1.1.3-1.7,0-.8-.3-1.1-1.1-1.1-.4,0-.8.1-1.2.2,0-.7,0-.8.7-1.1.9-.3,1.9-.6,2.9-.6,1.5,0,2.4,1,2.2,2.5-.2,1.2-.6,2.4-.9,3.6-.2.6-.3,1.3-.4,1.9-.1.7.2,1.1,1,1.1.5,0,1,0,1.5-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.6,11.7c-1.1,0-2.1-.8-2.1-1.9,0-1,.9-1.9,2.1-1.9,1.1,0,2,.8,2,1.8,0,1-.9,1.9-2,1.9Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInformation);
export default __webpack_public_path__ + "static/media/circle-information.27e7b47240e14aa18cd91f553f23b2b3.svg";
export { ForwardRef as ReactComponent };